<template lang="pug">
div(:key="optionModel.name")
  el-form-item(label="多选")
    el-switch(v-model="multiple2")
  el-divider 数据来源
  el-form-item(label="启用数据源")
    el-switch(v-model="dsEnabled")
  template(v-if="isSqlModel")
    table-setting(v-model="tableId")
    table-field-setting(v-model="valueField", label="主键字段", :tableId="tableId")
    table-field-setting(v-model="titleField", label="显示字段", :tableId="tableId")
    table-field-setting(v-model="columnField", label="列表字段", collapse-tags, multiple, :tableId="tableId")
    template(v-if="columnField && columnField.length")
      draggable.col-list(v-if="columnField && columnField.length", :list="columnField")
        li.col-item(v-for="field in columnField", :key="field")
          i.iconfont.icon-drag.item-drag
          p {{ field }}
      table-field-setting(v-model="filterField", label="可筛选字段", collapse-tags, multiple, :tableId="tableId")
  template(v-else)
    el-form-item(label="指定数据源")
      el-select(v-model="dsName", filterable, clearable)
        el-option(v-for="item in dataSourceList", :key="item.uniqueName", :title="item.description", :label="item.uniqueName", :value="item.uniqueName")
    el-form-item(label="主键字段")
      el-input(v-model="valueField")
    el-form-item(label="显示字段")
      el-input(v-model="titleField")
    el-form-item(label="触发字段")
      el-select(v-model="dsTriggerFields", filterable, multiple, clearable)
        el-option-group(v-for="{ group, list } in dsFieldList", :key="group", :label="group")
          el-option(v-for="{ cnName, id } in list", :key="id", :label="cnName", :value="id")
  el-form-item(label="默认第一条数据")
    el-switch(v-model="defaultFirst")
  el-button(type="text", icon="el-icon-edit", @click="openAssign") 编辑数据填充
  el-button(type="text", icon="el-icon-coin", @click="openSqlLayout", v-if="isSqlModel") 编辑筛选条件
  sql-dialog(ref="sqlDialog", @resolve="finishEditExpr")
</template>
<script>
import { cloneDeep, mapVFOptions, settingMixin } from "@/CommonDP/VForm/utils";
import metaFix from "./metaFix.vue";
import asyncCom from "@/CommonDP/commons/asyncCom";
import sqlDialog from "@/CommonDP/components/custom-dialog/sql/layout.vue";
import { subFormBus } from "../utils/panel-setting/subFormBus";
export default {
  components: { metaFix, sqlDialog },
  mixins: [settingMixin],
  inject: ["serverFieldList", "subformFieldList", "isSubFormChildWidget"],
  computed: {
    ...mapVFOptions(
      "filterField",
      "tableId",
      "columnField",
      "multiple2",
      "dsEnabled",
      "dsTriggerFields",
      "dsName",
      "assignData",
      "titleField",
      "valueField",
      "exprGroupList",
      "exprJoinOp",
      "defaultFirst"
    ),
    fieldList() {
      return this.isSubFormChildWidget() ? this.subformFieldList() : this.serverFieldList;
    },
    dsFieldList() {
      const { mainTableFields, subTableFields } = this;
      const list = [];
      if (mainTableFields?.length) list.push({ group: "主表", list: mainTableFields.map(({ name, label }) => ({ id: name, cnName: `主:${label}(${name})` })) });
      if (subTableFields?.length) list.push({ group: "从表", list: subTableFields.map(({ name, label }) => ({ id: name, cnName: `从:${label}` })) });
      return list;
    },
    mainTableFields() {
      return this.serverFieldList;
    },
    subTableFields() {
      return subFormBus.isSubformJyht ? subFormBus.list : [];
    },
    subTableId() {
      return subFormBus.isSubformJyht ? subFormBus.parentWidget?.options?.sublist : "";
    },
    mainTableId() {
      return this.mainTableFields.find(({ tableName }) => tableName)?.tableName;
    },
    curTable() {
      return this.subTableId || this.mainTableId;
    },
    dataSourceList() {
      return this.designer.formConfig?.dataSources || [];
    },
    isSqlModel() {
      return !this.dsEnabled;
    }
  },
  methods: {
    async openAssign() {
      const { assignData, tableId, dsEnabled } = this;
      const list = cloneDeep(assignData);
      const data = await asyncCom(metaFix, { list }, { fromId: dsEnabled ? "" : tableId, toId: this.curTable, subFormId: subFormBus.subFormFieldNum });
      this.assignData = data;
    },
    async openSqlLayout() {
      const { mainTableId, subTableId, tableId, exprJoinOp, exprGroupList } = this;
      const a = {
        exprJoinOp,
        subTableId,
        exprGroupList: exprGroupList || [],
        keyTableId: tableId,
        valTableId: mainTableId
      };
      const params = cloneDeep(a);
      console.log(a === params);
      this.$refs.sqlDialog.show(params);
    },

    finishEditExpr(data) {
      this.exprJoinOp = data.exprJoinOp;
      this.exprGroupList = cloneDeep(data.exprGroupList);
    }
  }
};
</script>
<style lang="scss" scoped>
.col-list {
  border: 1px solid #ddd;
  border-radius: 2px;
  padding: 2px 4px;
  margin-bottom: 6px;
}
.col-item {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  color: var(--info-color);
  transition: all 0.2s;
  padding: 0 6px 0 4px;
  cursor: grab;
  &:hover {
    background-color: rgba(var(--theme-color), 0.08);
  }
  .item-drag {
    font-size: 14px;
  }
  > p {
    user-select: none;
  }
}
</style>
